$(".text_button_sample").click(function(){
  $(".sample_request_block").fadeIn(2000);
});

$(".sample_request_close").click(function(){
  $(".sample_request_block").fadeOut(2000);
});

$(".text_button_brochure").click(function(){
  $(".brochure_block").fadeIn(2000);
});

$(".brochure_close").click(function(){
  $(".brochure_block").fadeOut(2000);
});



$(document).ready(function() {
  
      $('#email-input, #text-input').on('keyup', function() {
let email = $('#email-input').val().trim();
let text = $('#text-input').val();
let button = $('.brochure_submit');
let button_1 = $('.download-button_1');
let button_2 = $('.download-button_2');
let button_3 = $('.download-button_3');
let button_4 = $('.download-button_4');
        if (email === '' && text === '') {
          // button.attr('disabled','disabled');
          
          // button_1.removeAttr('target','_blank');
          // button_1.removeAttr('download');
          // button_1.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Gas_Fires_2023.pdf?v=1687427194');

          // button_2.removeAttr('target','_blank');
          // button_2.removeAttr('download');
          // button_2.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces_for_Stoves.pdf');

          // button_3.removeAttr('target','_blank');
          // button_3.removeAttr('download');
          // button_3.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Electric_Fires_2023.pdf');

          // button_4.removeAttr('target','_blank');
          // button_4.removeAttr('download');
          // button_4.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces.pdf');
          
        } else if (email !== '' && !isValidEmail(email)) {
          // button.attr('disabled','disabled');
          // button_1.removeAttr('target','_blank');
          // button_1.removeAttr('download','file.pdf');
          // button_1.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Gas_Fires_2023.pdf');

          // button_2.removeAttr('target','_blank');
          // button_2.removeAttr('download');
          // button_2.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces_for_Stoves.pdf');

          // button_3.removeAttr('target','_blank');
          // button_3.removeAttr('download');
          // button_3.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Electric_Fires_2023.pdf.pdf');

          // button_4.removeAttr('target','_blank');
          // button_4.removeAttr('download');
          // button_4.removeAttr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces.pdf');
          
        } else if ((isValidEmail(email) == true) && (email !== '') && (text !== '') ) {
          // button.removeAttr('disabled','disabled');
          // button_1.attr('target','_blank');
          // button_1.attr('download','file.pdf');
          // button_1.attr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Gas_Fires_2023.pdf');

          // button_2.attr('target','_blank');
          // button_2.attr('download');
          // button_2.attr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces_for_Stoves.pdf');

          // button_3.attr('target','_blank');
          // button_3.attr('download');
          // button_3.attr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Electric_Fires_2023.pdf');

          // button_4.attr('target','_blank');
          // button_4.attr('download');
          // button_4.attr('href','https://cdn.shopify.com/s/files/1/0126/9212/7801/files/Brochure_Marble_Fireplaces.pdf');
          
        }
        
      });

      function isValidEmail(email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }
  
});


$(window).on('scroll', function() {

  var contentTop = $(".text_box_button_block").offset().top;
  
  if (($(this).scrollTop() > contentTop)) {
    $(".text_button_block").addClass('sticky');
  } else {
    $(".text_button_block").removeClass('sticky');
  }

});

